module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create-shop":"Create Shop","step-1-of-3":"Step 1 of 3"},"th":{"create-shop":"สร้างร้านค้า","step-1-of-3":"ขั้นตอนที่ 1 จาก 3"}}')
  delete Component.options._Ctor
}
